export const companyToAnalytics = {
  general: 'G-1EG1QG57E1',
  '66a78ee9-366e-4b9f-8cef-0ee6984c3c97': 'G-Q4GTWM5YN8'
}
